module.exports = __webpack_public_path__ + "img/charge_isuse.b9e3d08b.png";